module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-chunk-header-02@2x.bc9666de.jpg";